import React, { useEffect, useState } from 'react';
import Plan from './Plan';
import PlanList from './PlanList';
import { Slider } from '@material-ui/core';
import PlansComparison from './PlansComparison';
import { useSelector, shallowEqual } from 'react-redux';

const PLANS = {
	starter: {
		id: 'starter',
		title: 'Starter',
		billingCycle: 'Monthly',
		maxLimit: 3500,
		desc: 'Growth, 750 monthly orders',
		benifits: [
			'Community Feed',
			'Friends Invitation',
			'Customization (color, name...)',
			'Create all type of posts',
			'User notification on answer',
		],
	},
	pro: {
		id: 'pro',
		title: 'Pro',
		billingCycle: 'Monthly',
		maxLimit: 10000,
		desc: 'Growth, 1000 monthly orders',
		benifits: [
			'Challenge',
			'Schedule Posts',
			'Dashboard',
			'Collect Video Review',
			'Influencer Page',
			'Moderation in Dashboard',
			'Feed in Dashboard',
		],
	},
	premium: {
		id: 'premium',
		title: 'Premium',
		billingCycle: 'Monthly',
		maxLimit: 11000,
		desc: 'Growth, 1000 monthly orders',
		benifits: [
			'Admin Email notifications',
			'Auto Customer Service',
			'UGC in PDP',
			'Stories',
		],
	},
};
const PLANPRICING = [
	{
		monthlySessions: 100,
		pricing: {
			starter: 15,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 500,
		pricing: {
			starter: 49,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 1000,
		pricing: {
			starter: 79,
			pro: null,
			premium: null,
		},
	},
	{
		monthlySessions: 2000,
		pricing: {
			starter: 129,
			pro: 199,
			premium: null,
		},
	},
	{
		monthlySessions: 3500,
		pricing: {
			starter: 199,
			pro: 299,
			premium: null,
		},
	},
	{
		monthlySessions: 5000,
		pricing: {
			starter: null,
			pro: 399,
			premium: null,
		},
	},
	{
		monthlySessions: 10000,
		pricing: {
			starter: null,
			pro: 499,
			premium: null,
		},
	},
	{
		monthlySessions: 11000,
		pricing: {
			starter: null,
			pro: null,
			premium: 'CONTACTUS',
		},
	},
];
const marks = [
	{
		value: 0,
		pricing: {
			starter: 79,
		},
		label: '30K',
		monthlySessions: 900,
	},
	{
		value: 20,
		pricing: {
			starter: 99,
			pro: 199,
		},
		label: '60K',
		monthlySessions: 1800,
	},
	{
		value: 40,
		pricing: {
			pro: 299,
		},
		label: '100K',
		monthlySessions: 3000,
	},
	{
		value: 60,
		pricing: {
			pro: 399,
		},
		label: '200K',
		monthlySessions: 6000,
	},
	{
		value: 80,
		pricing: {
			pro: 499,
		},
		label: '300K',
		monthlySessions: 9000,
	},
	{
		value: 100,
		pricing: {
			premium: 'CONTACTUS',
		},
		label: '>300K',
		monthlySessions: '~',
	},
];

const Overview = () => {
	const [pricePlan, setPricePlan] = useState(PLANPRICING[0]); //selected plan
	const [sliderVal, setSliderVal] = useState(0);
	const [selected, setSelected] = useState(PLANS.starter.id); //id of selected(starter,pro,premium)
	const [merchantPaymentPlan, setMerchantPaymentPlan] = useState(null);

	const merchant = useSelector(state => state.merchants.merchants, shallowEqual)[0];
	const changePlanSlider = (event, newValue) => {
		if (sliderVal !== newValue) {
			setSliderVal(newValue)
		}
	};

	useEffect(() => {
		if (!merchantPaymentPlan) {
			return;
		}
		const planToPreselect = marks.find(plan =>
			plan.monthlySessions === merchant.monthlySessions ||
			plan.monthlySessions === parseInt(merchant.monthlySessions)
		);
		if (!planToPreselect) {
			return;
		}
		changePlanSlider(null, planToPreselect.value);
		setTimeout(() => {
			setSelected(merchantPaymentPlan.plan.toLowerCase())
		}, 100);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [merchantPaymentPlan]);

	useEffect(() => {
		const hasSubscriptionMethod = merchant.shopify || merchant.plan;
		if (hasSubscriptionMethod && hasSubscriptionMethod.payment_status) {
			setMerchantPaymentPlan(hasSubscriptionMethod)
		};
		if (merchant.shopify || merchant.merchantId?.includes('shopify')) {
			PLANPRICING.pop();
			marks.pop();
			marks.forEach(mark => mark.value *= 1.25)
			delete PLANS.premium;
		}
	}, [merchant]);

	useEffect(() => {
		let plan = marks.find(e => e.value === sliderVal);
		if (plan) {
			setPricePlan(plan);
		}
	}, [sliderVal]);

	useEffect(() => {
		for (let key of Object.keys(pricePlan?.pricing || {})) {
			if (pricePlan.pricing[key]) {
				setSelected(PLANS[key].id);
				break;
			}
		}
	}, [pricePlan]);

	return (
		<>
			<div className='overview-wrapper'>
				<div>
					<div className='align-items-start d-flex flex-column mb-5'>
						<span className='fs-1 mb-2'>Choose your plan</span>
						<span className='fs-6 mb-2 text-Silver'>
							Choose a flexible plan, designed to scale with you
						</span>
					</div>
					<div className='slider-wrapper'>
						<span className='fs-6 fw-bold mb-5 d-block'>
							Estimated Monthly Traffic:
						</span>
						<Slider
							value={sliderVal}
							onChange={changePlanSlider}
							step={null}
							valueLabelDisplay="off"
							marks={marks}
							style={{ maxWidth: '1000px' }}
						/>
					</div>
					<PlanList
						pricePlan={pricePlan}
						PLANS={PLANS}
						selected={selected}
						setSelected={setSelected}
						setSliderVal={setSliderVal}
					/>
				</div>
				<Plan billingInterval={merchant.billingInterval} merchantPaymentPlan={merchantPaymentPlan} selected={selected} pricePlan={pricePlan} PLANPRICING={PLANPRICING} PLANS={PLANS} />
				<PlansComparison selected={selected} isShopify={merchant?.shopify} />
			</div>
		</>
	);
};
export default Overview;
